export interface Tag {
  id: number;
  name: string;
  trackCount: number;
  search_aliases?: string[] | null;
  category?: string | null;
  vector_prompt?: string | null;
  has_embedding?: boolean;
  vector_model_version?: string | null;
}

// Урезанный тег из эндпоинта рекомендаций. score — косинусная близость к
// центроиду треков ×100 (0-100): читать как порядок/уверенность, не вероятность.
export interface TagRecommendation {
  id: number;
  name: string;
  category: string | null;
  score: number;
}

export const createTag = (): Tag => ({
  id: 0,
  name: '',
  trackCount: 0
});

export const fillTag = (src: Tag, dst: Tag) => {
  dst.id = src.id;
  dst.name = src.name;
  dst.trackCount = src.trackCount;

  dst.search_aliases?.splice(0);
  if (src.search_aliases) {
    dst.search_aliases?.push(...src.search_aliases);
  }

  dst.category = src.category;
  dst.vector_prompt = src.vector_prompt;
  dst.has_embedding = src.has_embedding;
  dst.vector_model_version = src.vector_model_version;
};

export interface TagForm {
  id?: number;
  search_aliases: string[];
  name: string;
}

export const createTagForm = (tg?: Tag): TagForm => ({
  id: tg ? tg.id : undefined,
  search_aliases: tg?.search_aliases || [],
  name: tg ? tg.name : ''
});
